/**
 * Best-effort HTML → Markdown for sharing export (content from contentEditable).
 */
export function richTextHtmlToMarkdown(rootHtml: string): string {
  const d = document.createElement('div');
  d.innerHTML = rootHtml;

  function text(t: string | null): string {
    return (t ?? '').replace(/\r\n/g, '\n');
  }

  function walk(node: Node, listDepth = 0): string {
    if (node.nodeType === Node.TEXT_NODE) return text(node.textContent);
    if (node.nodeType !== Node.ELEMENT_NODE) return '';

    const el = node as HTMLElement;
    const tag = el.tagName.toLowerCase();
    const kids = () => Array.from(el.childNodes).map((c) => walk(c, tag === 'ul' || tag === 'ol' ? listDepth + 1 : listDepth)).join('');

    switch (tag) {
      case 'br':
        return '\n';
      case 'strong':
      case 'b':
        return `**${kids()}**`;
      case 'em':
      case 'i':
        return `*${kids()}*`;
      case 's':
      case 'strike':
      case 'del':
        return `~~${kids()}~~`;
      case 'u':
        return kids();
      case 'code':
        return `\`${kids().replace(/\n/g, ' ')}\``;
      case 'a': {
        const href = el.getAttribute('href') ?? '';
        return `[${kids()}](${href})`;
      }
      case 'img': {
        const src = el.getAttribute('src') ?? '';
        const alt = el.getAttribute('alt') ?? '';
        return `![${alt}](${src})`;
      }
      case 'li':
        return `${'  '.repeat(Math.max(0, listDepth - 1))}- ${kids().replace(/^\n+|\n+$/g, '')}\n`;
      case 'ul':
      case 'ol':
        return `${kids()}\n`;
      case 'p':
      case 'div':
        return `${kids()}\n\n`;
      case 'h1':
        return `# ${kids().trim()}\n\n`;
      case 'h2':
        return `## ${kids().trim()}\n\n`;
      case 'h3':
        return `### ${kids().trim()}\n\n`;
      case 'hr':
        return '---\n\n';
      case 'blockquote':
        return kids()
          .split('\n')
          .map((l) => (l.trim() ? `> ${l}` : '>'))
          .join('\n');
      default:
        return kids();
    }
  }

  const out = walk(d).replace(/\n{3,}/g, '\n\n').trim();
  return out;
}
